export function GPSMonumentTemplate(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Monument Type</th>
                  <td class="two-third">{Type}</td>
              </tr>
              <tr>
                  <th class="third">1999 Survey File</th>
                  <td class="two-third">
                      <a target="_blank" href="https://www.dmcgis.com/images/GPSMon/1999/{Point_Num}.pdf" class="ui fluid tiny button">View PDF</a>
                  </td>
              </tr>
              <tr>
                  <th class="third">2012 Survey File</th>
                  <td class="two-third">
                      <a target="_blank" href="https://www.dmcgis.com/images/GPSMon/2012/{Point_Num}.pdf" class="ui fluid tiny button">View PDF</a>
                  </td>
              </tr>
              <tr>
                  <th class="third">2017 Survey File</th>
                  <td class="two-third">
                      <a target="_blank" href="https://www.dmcgis.com/images/GPSMon/2017/{Point_Num}.pdf" class="ui fluid tiny button">View PDF</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  